import { createFileRoute } from '@tanstack/react-router'
import AdminUsersPage from '@/components/pages/Admin/AdminUsersPage/AdminUsersPage'
import { z } from 'zod'

const searchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
  sort_by: z.string().optional(),
  sort_order: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/admin/users/')({
  validateSearch: (search) => searchSchema.parse(search),
  component: AdminUsersRoute,
})

function AdminUsersRoute() {
  return <AdminUsersPage />
}
